import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { LicenseOfficeType, } from '@models';
import { aggregateLicenseUsage } from '@pages/shared/chart.config';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
export var LicenseUrlMap;
(function (LicenseUrlMap) {
    LicenseUrlMap["unattended"] = "Unattended";
    LicenseUrlMap["nonproduction"] = "NonProduction";
    LicenseUrlMap["development"] = "Development";
    LicenseUrlMap["studiox"] = "StudioX";
    LicenseUrlMap["attended"] = "Attended";
})(LicenseUrlMap || (LicenseUrlMap = {}));
export var LicenseUrlMapBackOffice;
(function (LicenseUrlMapBackOffice) {
    LicenseUrlMapBackOffice["unattended"] = "Unattended";
    LicenseUrlMapBackOffice["nonproduction"] = "NonProduction";
})(LicenseUrlMapBackOffice || (LicenseUrlMapBackOffice = {}));
export var LicenseUrlMapFrontOffice;
(function (LicenseUrlMapFrontOffice) {
    LicenseUrlMapFrontOffice["development"] = "Development";
    LicenseUrlMapFrontOffice["studiox"] = "StudioX";
    LicenseUrlMapFrontOffice["attended"] = "Attended";
})(LicenseUrlMapFrontOffice || (LicenseUrlMapFrontOffice = {}));
export var licenseOfficeType = function (licenseType) {
    switch (licenseType) {
        case LicenseUrlMap.unattended:
        case LicenseUrlMap.nonproduction:
            return LicenseOfficeType.BackOffice;
        case LicenseUrlMap.development:
        case LicenseUrlMap.studiox:
        case LicenseUrlMap.attended:
            return LicenseOfficeType.FrontOffice;
        default:
            throw new Error('Unknown licenseType');
    }
};
var generateRuntimeEndpoint = function (type) {
    return "/odata/LicensesRuntime/UiPath.Server.Configuration.OData.GetLicensesRuntime(robotType='" + type + "')";
};
var ɵ0 = generateRuntimeEndpoint;
var generateNamedUserEndpoint = function (type) {
    return "/odata/LicensesNamedUser/UiPath.Server.Configuration.OData.GetLicensesNamedUser(robotType='" + type + "')";
};
var ɵ1 = generateNamedUserEndpoint;
var RuntimeLicenseService = /** @class */ (function (_super) {
    tslib_1.__extends(RuntimeLicenseService, _super);
    function RuntimeLicenseService(http) {
        var _this = _super.call(this, http, MapperService.runtimeLicenseMap) || this;
        _this._endpoint = '';
        return _this;
    }
    RuntimeLicenseService.prototype.getLicenseDetails = function (licenseType, queryOptions) {
        this._endpoint = generateRuntimeEndpoint(licenseType);
        return this.get(queryOptions);
    };
    RuntimeLicenseService.prototype.toggleEnabled = function (license, licenseType) {
        var data = {
            'key': license.key,
            'robotType': licenseType,
            'enabled': license.enabled,
        };
        return this._http.post("/odata/LicensesRuntime('" + license.machineName + "')/UiPath.Server.Configuration.OData.ToggleEnabled", JSON.stringify(data));
    };
    return RuntimeLicenseService;
}(ODataService));
export { RuntimeLicenseService };
var NamedUserLicenseService = /** @class */ (function (_super) {
    tslib_1.__extends(NamedUserLicenseService, _super);
    function NamedUserLicenseService(http) {
        var _this = _super.call(this, http, MapperService.namedLicenseMap) || this;
        _this._endpoint = '';
        return _this;
    }
    NamedUserLicenseService.prototype.getLicenseDetails = function (licenseType, queryOptions) {
        this._endpoint = generateNamedUserEndpoint(licenseType);
        return this.get(queryOptions);
    };
    return NamedUserLicenseService;
}(ODataService));
export { NamedUserLicenseService };
var LicenseUsageService = /** @class */ (function () {
    function LicenseUsageService(_http) {
        this._http = _http;
        this._endpoint = '/api/stats';
    }
    LicenseUsageService.prototype.getTenantStatsById = function (tenantId, daysNo) {
        return this._http
            .get(this._endpoint + "/GetLicenseStats?tenantId=" + tenantId + "&days=" + daysNo)
            .pipe(map(function (res) { return aggregateLicenseUsage(res, daysNo); }));
    };
    return LicenseUsageService;
}());
export { LicenseUsageService };
export { ɵ0, ɵ1 };
